import DialogGuide from 'global/guides/Dialog'
import { useEscalasOutletContext } from 'pages/Escalas'
import { useNavigate, useParams } from 'react-router-dom'
import {
    CreateEscalaInput,
    createEscalaSchema,
    escalas,
} from 'service/api/endpoints/escalas'
import { toast } from 'sonner'
import FormularioEscala from '../forms/Forms'

function EditarEscalaModal() {
    const navigate = useNavigate()
    const { id } = useParams()
    const { isLoading, mutate } = escalas.mutations.useUpdate({
        invalidateQuery: true,
    })

    const { data } = useEscalasOutletContext()
    const find = data.find(item => item.id === Number(id))

    const handleSubmit = (data: CreateEscalaInput) =>
        mutate(
            {
                id: Number(id),
                ...data,
            },
            {
                onSuccess: () => {
                    toast.success('Editado com sucesso!')
                    navigate(-1)
                },
                onError: ({ statusCode, message }) => {
                    if (statusCode === 400) {
                        toast.error(message)
                    } else {
                        toast.error('Erro ao salvar escala!')
                    }
                },
            },
        )

    return (
        <DialogGuide.Root
            schema={createEscalaSchema}
            defaultValues={{
                ...find,
                emHoras: find?.tipo === 'HORISTA',
            }}
            height="auto"
            width="40rem"
            loading={isLoading}
            onSubmit={handleSubmit}
        >
            <DialogGuide.Title>Editar Escala</DialogGuide.Title>
            <DialogGuide.Content dividers>
                <FormularioEscala />
            </DialogGuide.Content>
            <DialogGuide.Actions>
                <DialogGuide.Actions.SecondaryButton>
                    Fechar
                </DialogGuide.Actions.SecondaryButton>
                <DialogGuide.Actions.PrimaryButton>
                    Salvar
                </DialogGuide.Actions.PrimaryButton>
            </DialogGuide.Actions>
        </DialogGuide.Root>
    )
}

export default EditarEscalaModal
